@let executionTypeRaw = form().getRawValue().executionType;

@if (isSingleExecution()) {
  <ng-container *ngTemplateOutlet="executionTypeHeaders" />
} @else {
  <mat-expansion-panel
    class="cta-expansion-panel"
    [expanded]="!isDisabled()"
    [disabled]="isDisabled() && isCustomMode() && !isViewMode()"
  >
    <mat-expansion-panel-header class="deliverable-flow-expansion-panel-header execution-panel-header">
      <mat-panel-title>
        <div class="flex flex-1 gap-2 justify-between items-center">
          <div class="flex flex-grow">
            <app-editable-title
              fontClasses="text-sm font-bold"
              [title]="
                'pages.campaignForm.ctaDialog.ctaDetails.executions.frequencyRule'
                  | translate: { count: executionNumber() }
              "
              [icon]="form().invalid ? 'icons/circle-x.svg' : 'icons/circle-check.svg'"
              [iconColor]="form().invalid ? 'var(--shikenso-error-bright)' : 'var(--shikenso-pink-base)'"
              [iconSize]="16"
              [control]="executionType"
              [prioritizeTitle]="true"
              [isViewMode]="isViewMode()"
              [disabled]="isDisabled()"
              [readonly]="true"
            />
          </div>

          <div class="flex gap-2 mr-4">
            @if (form().value.duration && form().value.duration >= 0) {
              <div class="flex items-center">
                <span class="text-xs">{{ form().value.duration | duration }}</span>
              </div>
            }

            @if (
              form().value.duration &&
              form().value.duration >= 0 &&
              ((form().value.executionDate && executionTypeRaw === EExecutionType.unique) ||
                (form().value.executionCountTarget && executionTypeRaw === EExecutionType.undesignated))
            ) {
              <span class="text-xs">-</span>
            }

            @if (form().value.executionDate && executionTypeRaw === EExecutionType.unique) {
              <div class="flex items-center">
                <span class="text-xs">{{ form().value.executionDate | date: 'MMM d' }}</span>

                @if (form().value.executionTime) {
                  <span class="text-xs">, {{ form().value.executionTime | date: 'HH:mm' }}</span>
                }
              </div>
            }

            @if (form().value.executionCountTarget && executionTypeRaw === EExecutionType.undesignated) {
              <div class="flex items-center">
                <span class="text-xs">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypes.undesignated'
                      | translate: { count: form().value.executionCountTarget ?? 0 }
                  }}
                </span>
              </div>
            }

            @if (executionTypeRaw === EExecutionType.always) {
              <div class="flex items-center">
                <span class="text-xs">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypes.always'
                      | translate
                  }}
                </span>
              </div>
            }
          </div>

          @if (!isViewMode()) {
            <div class="flex items-center">
              @if (isCustomMode() && !form().value.exclusiveTo) {
                <app-custom-remove-button
                  [checked]="!getCustomValueState('id')"
                  (checkboxStateChanged)="onDeleteCheckboxChange('id', $event)"
                  #deleteParentButton
                />
              } @else {
                <button
                  mat-icon-button
                  class="mat-secondary-transparent-button-color"
                  (click)="onDeleteClick(form().value.exclusiveTo)"
                >
                  <app-icon src="/icons/trash.svg" alt="delete" [size]="16" />
                </button>
              }
            </div>
          }
        </div>
      </mat-panel-title>

      @if (isDisabled()) {
        <svg
          class="absolute top-1/2 -translate-y-1/2 right-1 opacity-[24%] w-6 h-6 mt-[1px]"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 -960 960 960"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"></path>
        </svg>
      }
    </mat-expansion-panel-header>

    <ng-container *ngTemplateOutlet="executionTypeHeaders" />
  </mat-expansion-panel>
}

<ng-template #executionTypeHeaders>
  <div class="flex flex-col gap-3">
    @let uniquePanelDisabled =
      (isDisabled() && isCustomMode() && !isViewMode()) ||
      (isCustomMode() &&
        form().get('executionType')?.value !== EExecutionType.unique &&
        !form().get('exclusiveTo')?.value);
    @let displayUniqueLockIcon =
      isCustomMode() && !isViewMode() && !form().get('exclusiveTo')?.value && !uniquePanelDisabled;

    <mat-expansion-panel
      class="cta-expansion-panel"
      [class.active-expansion-panel]="executionTypeRaw === EExecutionType.unique"
      [expanded]="executionTypeRaw === EExecutionType.unique"
      [disabled]="uniquePanelDisabled"
      (expandedChange)="onExecutionTypeExpansionChange($event, EExecutionType.unique, uniquePanel)"
      #uniquePanel="matExpansionPanel"
    >
      <mat-expansion-panel-header
        class="deliverable-flow-expansion-panel-header execution-panel-header hidden-expansion-indicator !h-auto"
      >
        <mat-panel-title [class.cursor-default]="uniquePanelDisabled">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-3 pl-1 py-3">
              <app-icon-badge
                content="icons/calendar-event.svg"
                backgroundColor="var(--shikenso-gray-base)"
                color="var(--shikenso-purple-base)"
                [class.opacity-60]="uniquePanelDisabled"
                [size]="40"
                [iconSize]="16"
              />

              <div class="flex flex-col">
                <span class="font-bold leading-6">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.unique.title'
                      | translate
                  }}
                </span>
                <span class="text-xs text-shikenso-purple-base-60">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.unique.description'
                      | translate
                  }}
                </span>
              </div>
            </div>

            @if (displayUniqueLockIcon) {
              <ng-container *ngTemplateOutlet="lockIcon" />
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngTemplateOutlet="executionForm" />
    </mat-expansion-panel>

    @let undesignatedPanelDisabled =
      (isDisabled() && isCustomMode() && !isViewMode()) ||
      (isCustomMode() &&
        form().get('executionType')?.value !== EExecutionType.undesignated &&
        !form().get('exclusiveTo')?.value);
    @let displayUndesignatedLockIcon =
      isCustomMode() && !isViewMode() && !form().get('exclusiveTo')?.value && !undesignatedPanelDisabled;

    <mat-expansion-panel
      class="cta-expansion-panel"
      [class.active-expansion-panel]="executionTypeRaw === EExecutionType.undesignated"
      [expanded]="executionTypeRaw === EExecutionType.undesignated"
      [disabled]="undesignatedPanelDisabled"
      (expandedChange)="onExecutionTypeExpansionChange($event, EExecutionType.undesignated, undesignatedPanel)"
      #undesignatedPanel="matExpansionPanel"
    >
      <mat-expansion-panel-header
        class="deliverable-flow-expansion-panel-header execution-panel-header hidden-expansion-indicator !h-auto"
      >
        <mat-panel-title [class.cursor-default]="undesignatedPanelDisabled">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-3 pl-1 py-3">
              <app-icon-badge
                content="icons/repeat.svg"
                backgroundColor="var(--shikenso-gray-base)"
                color="var(--shikenso-purple-base)"
                [class.opacity-60]="undesignatedPanelDisabled"
                [size]="40"
                [iconSize]="16"
              />

              <div class="flex flex-col">
                <span class="font-bold leading-6">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.undesignated.title'
                      | translate
                  }}
                </span>
                <span class="text-xs text-shikenso-purple-base-60">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.undesignated.description'
                      | translate
                  }}
                </span>
              </div>
            </div>

            @if (displayUndesignatedLockIcon) {
              <ng-container *ngTemplateOutlet="lockIcon" />
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <ng-container *ngTemplateOutlet="executionForm" />
    </mat-expansion-panel>

    @let alwaysPanelDisabled =
      (isDisabled() && isCustomMode() && !isViewMode()) ||
      (isCustomMode() &&
        form().get('executionType')?.value !== EExecutionType.always &&
        !form().get('exclusiveTo')?.value);
    @let displayAlwaysLockIcon =
      isCustomMode() && !isViewMode() && !form().get('exclusiveTo')?.value && !alwaysPanelDisabled;

    <mat-expansion-panel
      class="cta-expansion-panel"
      [class.active-expansion-panel]="executionTypeRaw === EExecutionType.always"
      [expanded]="executionTypeRaw === EExecutionType.always"
      [disabled]="alwaysPanelDisabled"
      (expandedChange)="onExecutionTypeExpansionChange($event, EExecutionType.always, alwaysPanel)"
      #alwaysPanel="matExpansionPanel"
    >
      <mat-expansion-panel-header
        class="deliverable-flow-expansion-panel-header execution-panel-header hidden-expansion-indicator !h-auto"
      >
        <mat-panel-title [class.cursor-default]="alwaysPanelDisabled">
          <div class="flex items-center justify-between w-full">
            <div class="flex items-center gap-3 pl-1 py-3">
              <app-icon-badge
                content="icons/infinity.svg"
                backgroundColor="var(--shikenso-gray-base)"
                color="var(--shikenso-purple-base)"
                [class.opacity-60]="alwaysPanelDisabled"
                [size]="40"
                [iconSize]="16"
              />

              <div class="flex flex-col">
                <span class="font-bold leading-6">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.always.title'
                      | translate
                  }}
                </span>
                <span class="text-xs text-shikenso-purple-base-60">
                  {{
                    'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.always.description'
                      | translate
                  }}
                </span>
              </div>
            </div>

            @if (displayAlwaysLockIcon) {
              <ng-container *ngTemplateOutlet="lockIcon" />
            }
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <span class="text-xs text-shikenso-purple-base-60">
        {{
          'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.executionTypeHeaders.always.noInputNeeded'
            | translate
        }}
      </span>
    </mat-expansion-panel>
  </div>
</ng-template>

<ng-template #executionForm>
  <div class="flex flex-col gap-4 custom-form" [formGroup]="form()">
    @if (executionTypeRaw !== EExecutionType.always) {
      <div class="flex flex-1 gap-4">
        @if (!isNonStreamPlatformFeature()) {
          <div class="flex flex-[0.4] flex-col gap-2">
            <div class="flex items-center gap-1 text-sm font-bold">
              <span>{{ 'pages.campaignForm.ctaDialog.ctaDetails.executions.duration' | translate }}</span>
            </div>

            <mat-form-field
              class="min-w-40 flex-1"
              [class.custom-value-border]="
                isCustomMode() && (getCustomValueState('duration') || form().value.exclusiveTo)
              "
            >
              <input matInput type="text" formControlName="duration" numberOnly />

              <div matSuffix class="flex items-center gap-1">
                <span class="text-[10px]">{{ 'shared.timeSuffixLong.minutes' | translate }}</span>

                @if (isCustomMode() && !isViewMode() && getCustomValueState('duration') && !form().value.exclusiveTo) {
                  <button
                    mat-icon-button
                    type="button"
                    class="mat-secondary-transparent-button-color"
                    [disabled]="isDisabled()"
                    (click)="onRevertToGlobalClick('duration')"
                  >
                    <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
                  </button>
                }
              </div>
              <mat-error [control]="form().get('duration')" />
            </mat-form-field>
          </div>
        }

        @if (executionTypeRaw === EExecutionType.undesignated) {
          <div
            class="flex flex-col gap-2"
            [ngClass]="{
              'flex-[0.6]': !isNonStreamPlatformFeature(),
              'flex-1': isNonStreamPlatformFeature(),
            }"
          >
            <div class="flex items-center gap-1 text-sm font-bold">
              <span>{{ 'pages.campaignForm.ctaDialog.ctaDetails.executions.count' | translate }}</span>
            </div>

            <mat-form-field
              class="flex-1"
              [class.custom-value-border]="
                isCustomMode() && (getCustomValueState('executionCountTarget') || form().value.exclusiveTo)
              "
            >
              <input matInput type="text" formControlName="executionCountTarget" numberOnly />

              <div matSuffix class="flex items-center gap-1">
                @if (
                  isCustomMode() &&
                  !isViewMode() &&
                  getCustomValueState('executionCountTarget') &&
                  !form().value.exclusiveTo
                ) {
                  <button
                    mat-icon-button
                    type="button"
                    class="mat-secondary-transparent-button-color"
                    [disabled]="isDisabled()"
                    (click)="onRevertToGlobalClick('executionCountTarget')"
                  >
                    <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
                  </button>
                }
              </div>
              <mat-error [control]="form().get('executionCountTarget')" />
            </mat-form-field>
          </div>
        }

        @if (executionTypeRaw === EExecutionType.unique) {
          <div
            class="flex flex-col gap-2"
            [ngClass]="{
              'flex-[0.6]': !isNonStreamPlatformFeature(),
              'flex-1': isNonStreamPlatformFeature(),
            }"
          >
            <div class="flex items-center gap-1 text-sm font-bold">
              <span>{{ 'pages.campaignForm.ctaDialog.ctaDetails.executions.timestamp' | translate }}</span>
            </div>

            <div class="flex flex-1 gap-2">
              <div
                class="flex flex-1 cursor-pointer"
                [class.cursor-default]="form().disabled"
                [class.pointer-events-none]="form().disabled"
                (click)="openDatePicker(datePicker)"
              >
                <mat-form-field
                  class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
                  [class.custom-value-border]="
                    isCustomMode() && (getCustomValueState('executionDate') || form().value.exclusiveTo)
                  "
                  matTooltip="{{ minDate | date: 'mediumDate' }} - {{ maxDate | date: 'mediumDate' }}"
                  matTooltipPosition="above"
                  #dateTooltip="matTooltip"
                >
                  <div class="opacity-0 absolute">
                    <input
                      matInput
                      formControlName="executionDate"
                      [matDatepicker]="datePicker"
                      [min]="minDate"
                      [max]="maxDate"
                      (dateChange)="onDateChange($event)"
                    />
                  </div>

                  <input
                    readonly
                    matInput
                    [value]="form().get('executionDate')?.value | date: 'dd.MM.yyyy'"
                    [placeholder]="
                      isViewMode()
                        ? ('pages.campaignForm.sections.basics.startDate' | translate)
                        : ('pages.campaignForm.sections.basics.startDatePlaceholder' | translate)
                    "
                  />
                  <div
                    matSuffix
                    class="flex items-center gap-1"
                    [class.cursor-default]="form().disabled"
                    [class.pointer-events-none]="form().disabled"
                  >
                    @if (form().get('executionDate')?.value && !isViewMode()) {
                      <button
                        mat-icon-button
                        type="button"
                        class="mat-secondary-transparent-button-color"
                        [disabled]="form().disabled"
                        (click)="clearDate($event)"
                      >
                        <app-icon src="/icons/close.svg" class="w-4 h-4" />
                      </button>
                    }

                    @if (
                      isCustomMode() &&
                      !isViewMode() &&
                      getCustomValueState('executionDate') &&
                      !form().value.exclusiveTo
                    ) {
                      <button
                        mat-icon-button
                        type="button"
                        class="mat-secondary-transparent-button-color"
                        [disabled]="form().disabled"
                        (click)="onRevertToGlobalClick('executionDate', undefined, $event)"
                      >
                        <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
                      </button>
                    }
                  </div>
                  <mat-datepicker #datePicker />
                  <mat-error fieldName="executionDate" [control]="form().get('executionDate')" />
                </mat-form-field>
              </div>

              <div
                class="flex flex-1 cursor-pointer"
                [class.cursor-default]="form().disabled || form().get('executionTime')?.disabled"
                [class.pointer-events-none]="form().disabled || form().get('executionTime')?.disabled"
                (click)="openTimepicker($event, timePicker)"
              >
                <mat-form-field
                  class="flex-1 [&_input]:pointer-events-none"
                  [class.custom-value-border]="
                    isCustomMode() &&
                    canDisplayTimeCustomValue() &&
                    (getCustomValueState('executionTime') || form().value.exclusiveTo)
                  "
                  matTooltip="{{ minDate | date: 'MMM d, HH:mm' }} - {{ maxDate | date: 'MMM d, HH:mm' }}"
                  matTooltipPosition="above"
                  #timeTooltip="matTooltip"
                >
                  <input
                    matInput
                    formControlName="executionTime"
                    [matTimepickerMin]="minTime"
                    [matTimepickerMax]="maxTime"
                    [matTimepicker]="timePicker"
                    [placeholder]="
                      isViewMode()
                        ? ('pages.campaignForm.sections.basics.startTime' | translate)
                        : ('pages.campaignForm.sections.basics.startTimePlaceholder' | translate)
                    "
                    [value]="form().get('executionTime')?.value"
                    (focus)="selectAllText($event)"
                    (input)="onTimeInputChange($event, timePicker)"
                  />
                  <div
                    matSuffix
                    class="flex items-center gap-1"
                    [class.cursor-default]="form().disabled || form().get('executionTime')?.disabled"
                  >
                    @if (form().get('executionTime')?.value && !isViewMode()) {
                      <button
                        mat-icon-button
                        type="button"
                        class="mat-secondary-transparent-button-color"
                        [disabled]="form().disabled || form().get('executionTime')?.disabled"
                        (click)="clearTime($event)"
                      >
                        <app-icon src="/icons/close.svg" alt="info" class="w-4 h-4" />
                      </button>
                    }

                    @if (
                      isCustomMode() &&
                      !isViewMode() &&
                      canDisplayTimeCustomValue() &&
                      getCustomValueState('executionTime') &&
                      !form().value.exclusiveTo
                    ) {
                      <button
                        mat-icon-button
                        type="button"
                        class="mat-secondary-transparent-button-color"
                        [disabled]="form().disabled || form().get('executionTime')?.disabled"
                        (click)="onRevertToGlobalClick('executionTime', undefined, $event)"
                      >
                        <app-icon src="/icons/rotate-360.svg" class="w-4 h-4" />
                      </button>
                    }
                  </div>
                  <mat-timepicker #timePicker [options]="filteredTimeOptions" (selected)="onTimeSelected($event)" />
                  <mat-error fieldName="executionTime" [control]="form().get('executionTime')" />
                </mat-form-field>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- <app-expected-kpi-list
      [form]="expectedKpisForm()"
      [executionId]="executionId()"
      [platformFeature]="platformFeature()"
      [availableKpis]="availableKpis()"
      [creatorId]="creatorId()!"
      [isCustomMode]="isCustomMode()"
      [creators]="creators()"
      [isParentDeleteDisabled]="isDisabled()"
      [isViewMode]="isViewMode()"
    /> -->
  </div>
</ng-template>

<ng-template #lockIcon>
  <app-icon
    src="/icons/lock.svg"
    matTooltipPosition="above"
    [size]="16"
    [matTooltip]="'pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.executionStep.lockTooltip' | translate"
  />
</ng-template>
